import { Component, effect, OnInit } from '@angular/core';
import {
  IndicatorOverviewTableRow,
  TableServiceService,
} from '../../../services/indicator/table.service.service';
import { TreeTableModule } from 'primeng/treetable';
import { NgForOf, NgIf } from '@angular/common';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';

@Component({
  selector: 'app-overview-table-indicator',
  standalone: true,
  imports: [
    TreeTableModule,
    NgForOf,
    NgIf,
    InputTextModule,
    FormsModule,
    ChipModule,
  ],
  templateUrl: './overview-table-indicator.component.html',
  styleUrl: './overview-table-indicator.component.scss',
})
export class OverviewTableIndicatorComponent implements OnInit {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-screen',
    icon: 'fas fa-clipboard-list',
    headerText: 'Indikatorenbericht',
  };
  constructor(
    private sidebarService: SidebarService,
    private indicatorTableService: TableServiceService
  ) {
    effect(() => {
      if (this.table && this.table.length > 0) return;
      this.initTable();
    });
  }

  table: IndicatorOverviewTableRow[] = [];
  cols: any[] = [];

  ngOnInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }

  initTable() {
    this.cols = this.indicatorTableService.getTableColumns();
    this.table = this.indicatorTableService.indicatorRows();
  }
}
